import { createAction, props } from '@ngrx/store';
import { CwmConfig } from '@octiga/psa/cwm.interface';

export const loadMspCwmConfig = createAction('[MSP CWM] Load Config');
export const loadMspCwmConfigSuccess = createAction('[MSP CWM] Load Config Success', props<{ data: CwmConfig }>());
export const loadMspCwmConfigFailure = createAction('[MSP CWM] Load Config Failure', props<{ error: any }>());

export const updateMspCwmConfig = createAction('[MSP CWM] Update Config', props<{ data: CwmConfig }>());
export const updateMspCwmConfigSuccess = createAction('[MSP CWM] Update Config Success');
export const updateMspCwmConfigFailure = createAction('[MSP CWM] Update Config Failure', props<{ error: any }>());
